import { EntitiesApiTag, useRestApiProvider } from "@jugl-web/rest-api";
import { SubscriptionTags } from "@jugl-web/rest-api/subscription/tags";
import { useEntityProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntityProvider";
import { useAppDispatch } from "@web-src/store";
import { FC, useEffect } from "react";
import { entityLiveUpdates$ } from "../../entityLiveUpdates/events";
import { usePhoenixSocket } from "../../providers/usePhoenixSocket";

const ENTITY_LIVE_UPDATES_TOPIC = "entity";

export const EntityLiveUpdatesListener: FC = () => {
  const { updatesLobbyChannel, socketConnected } = usePhoenixSocket();
  const { entityId } = useEntityProvider();
  const { entitiesApi, subscriptionV2Api } = useRestApiProvider();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!updatesLobbyChannel || !entityId || !socketConnected) {
      return undefined;
    }

    updatesLobbyChannel.push("subscribe", { topic: ENTITY_LIVE_UPDATES_TOPIC });

    const invalidateSubscriptionState = () => {
      dispatch(
        subscriptionV2Api.util.invalidateTags([
          SubscriptionTags.subscriptionDetails,
          SubscriptionTags.topupConfig,
        ])
      );
      dispatch(
        entitiesApi.util.invalidateTags([
          EntitiesApiTag.getEntityList,
          { type: EntitiesApiTag.getSubscriptionInfo, id: entityId },
        ])
      );
    };

    const subscriptionUpdateRef = updatesLobbyChannel.on(
      "subscription_update",
      () => {
        invalidateSubscriptionState();
        entityLiveUpdates$.next({ type: "subscription_update" });
      }
    );

    const quotaUpdateRef = updatesLobbyChannel.on("quota_update", () => {
      invalidateSubscriptionState();
      entityLiveUpdates$.next({ type: "quota_update" });
    });

    return () => {
      updatesLobbyChannel.push("unsubscribe", {
        topic: ENTITY_LIVE_UPDATES_TOPIC,
      });
      updatesLobbyChannel.off("subscription_update", subscriptionUpdateRef);
      updatesLobbyChannel.off("quota_update", quotaUpdateRef);
    };
  }, [
    updatesLobbyChannel,
    entityId,
    socketConnected,
    dispatch,
    entitiesApi.util,
    subscriptionV2Api.util,
  ]);

  return null;
};
